/* eslint-disable radix */
import RestService from '../services/rest';


async function getCsvClientUserModel() {
  const response = await RestService.getAuthenticated('panel/clientUsers/csv/model', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'model-users-clients.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function uploadCsvClientUsers(file) {
  const fd = new FormData();
  fd.append('file', file);

  return RestService.postAuthenticated('panel/clientUsers/import', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

export default {
  getCsvClientUserModel,
  uploadCsvClientUsers,
};
